// Accessibility "fixes"
const quantityInput = document.querySelector('.koala-deal__quantity-input')
if (quantityInput) {
    const screenReaderLabel = document.createElement('span')
    screenReaderLabel.className = 'sr-only'
    screenReaderLabel.textContent = 'Select quantity'
    quantityInput.parentNode.insertBefore(screenReaderLabel, quantityInput) 
}

// Sticky ATC bar — Koala quantity breaks integration
(function initStickyKoala() {
  const container = document.querySelector('[data-sticky-koala-container]');

  if (!container) return;

  const toggle = container.querySelector('[data-sticky-koala-toggle]');
  const label = container.querySelector('[data-sticky-koala-label]');
  const dropdown = container.querySelector('[data-sticky-koala-dropdown]');
  let isOpen = false;

  function buildTiers(sourceWidget) {
    const tiers = sourceWidget.querySelectorAll('.koala-deal__tiers__list-item');

    if (!tiers.length) return;

    dropdown.innerHTML = '';
    container.style.display = '';

    tiers.forEach((tier) => {
      const input = tier.querySelector('.koala-deal__tier__input');

      if (!input) return;

      const title = tier.querySelector('.koala-deal__tier__title');
      const price = tier.querySelector('.koala-deal__tier__price');
      const subtitle = tier.querySelector('.koala-deal__tier__subtitle');
      const regularPrice = tier.querySelector('.koala-deal__tier__regular-price');
      const option = document.createElement('button');

      option.type = 'button';
      option.className = 'sticky-koala-option' + (input.checked ? ' is-active' : '');
      option.dataset.koalaTierId = input.id;

      const hasDiscount = regularPrice && !regularPrice.classList.contains('koala-deal__tier__regular-price--hidden');

      option.innerHTML =
        '<span class="sticky-koala-option__title">' + (title ? title.textContent.trim() : '') + '</span>' +
        '<span class="sticky-koala-option__pricing">' +
          '<span class="sticky-koala-option__price">' + (price ? price.textContent.trim() : '') + '</span>' +
          (hasDiscount ? '<span class="sticky-koala-option__regular-price">' + regularPrice.textContent.trim() + '</span>' : '') +
        '</span>' +
        (subtitle ? '<span class="sticky-koala-option__subtitle">' + subtitle.textContent.trim() + '</span>' : '');

      option.addEventListener('click', () => {
        input.checked = true;
        input.dispatchEvent(new Event('change', { bubbles: true }));
        input.click();
        updateActiveState(input.id);
        closeDropdown();
      });

      dropdown.appendChild(option);
    });

    updateLabel(sourceWidget);
  }

  function updateActiveState(activeId) {
    dropdown.querySelectorAll('.sticky-koala-option').forEach((opt) => {
      opt.classList.toggle('is-active', opt.dataset.koalaTierId === activeId);
    });

    const sourceWidget = document.querySelector('koala-quantity-breaks-embed');

    if (sourceWidget) updateLabel(sourceWidget);
  }

  function updateLabel(sourceWidget) {
    const checked = sourceWidget.querySelector('.koala-deal__tier__input:checked');

    if (!checked) return;

    const tier = checked.closest('.koala-deal__tiers__list-item') || checked.parentElement;
    const title = tier.querySelector('.koala-deal__tier__title');
    const price = tier.querySelector('.koala-deal__tier__price');

    label.textContent = (title ? title.textContent.trim() : 'Bundle') + (price ? ' — ' + price.textContent.trim() : '');
  }

  function closeDropdown() {
    isOpen = false;
    dropdown.style.display = 'none';
    toggle.querySelector('.sticky-koala-toggle__chevron').style.transform = '';
  }

  toggle.addEventListener('click', () => {
    isOpen = !isOpen;
    dropdown.style.display = isOpen ? '' : 'none';
    toggle.querySelector('.sticky-koala-toggle__chevron').style.transform = isOpen ? 'rotate(180deg)' : '';
  });

  // Watch for Koala widget to appear
  function tryInit() {
    const widget = document.querySelector('koala-quantity-breaks-embed');

    if (widget && widget.querySelector('.koala-deal__tiers__list-item')) {
      buildTiers(widget);
      // Listen for changes on original widget
      widget.addEventListener('change', () => {
        const checked = widget.querySelector('.koala-deal__tier__input:checked');

        if (checked) updateActiveState(checked.id);
      });
      return true;
    }
    return false;
  }

  if (!tryInit()) {
    const observer = new MutationObserver(() => {
      if (tryInit()) observer.disconnect();
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }
})();

const thumbnailsSplideEl = document.querySelector('.splide--thumbnails')
if (thumbnailsSplideEl) {
    setTimeout(() => {
        const vertThumbnailList = document.querySelector('[aria-orientation="vertical"]')
        if (vertThumbnailList) {
            vertThumbnailList.removeAttribute('aria-orientation')
        }
    }, 3000)
}